import React from 'react';
import { Bell, CheckCheck } from 'lucide-react';

const timeAgo = (date) => {
  const secs = Math.floor((Date.now() - new Date(date)) / 1000);
  if (secs < 60) return 'just now';
  if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
  return `${Math.floor(secs / 86400)}d ago`;
};

const typeStyles = {
  submission_approved: { dot: 'bg-green-500', label: 'Approved' },
  submission_rejected: { dot: 'bg-red-500', label: 'Rejected' },
  submission_commented: { dot: 'bg-blue-500', label: 'Feedback' },
  badge_earned: { dot: 'bg-yellow-500', label: 'Badge' }
};

const NotificationDropdown = ({ notifications, onMarkRead, onMarkAllRead, onClose }) => {
  const handleClick = (notification) => {
    if (!notification.read) onMarkRead(notification._id);
    onClose();
  };

  return (
    <div className="absolute right-0 top-full mt-2 w-80 rounded-xl shadow-lg bg-white border border-gray-100 z-50 overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 bg-gray-50 border-b border-gray-100 flex items-center justify-between">
        <span className="text-sm font-semibold text-gray-800">Notifications</span>
        {notifications.some(n => !n.read) && (
          <button
            onClick={onMarkAllRead}
            className="flex items-center gap-1 text-xs text-[#1086a4] hover:text-[#054581] transition-colors"
          >
            <CheckCheck className="w-3.5 h-3.5" />
            Mark all read
          </button>
        )}
      </div>

      {/* List */}
      <div className="max-h-80 overflow-y-auto">
        {notifications.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-10 text-center px-4">
            <Bell className="w-8 h-8 text-gray-300 mb-2" />
            <p className="text-sm text-gray-400">No notifications yet</p>
          </div>
        ) : (
          notifications.map(n => {
            const style = typeStyles[n.type] || { dot: 'bg-gray-400' };
            return (
              <button
                key={n._id}
                onClick={() => handleClick(n)}
                className={`w-full text-left px-4 py-3 border-b border-gray-50 hover:bg-gray-50 transition-colors flex items-start gap-3 ${!n.read ? 'bg-blue-50/40' : ''}`}
              >
                <span className={`mt-1.5 w-2 h-2 rounded-full flex-shrink-0 ${style.dot}`} />
                <div className="flex-1 min-w-0">
                  <p className={`text-xs font-semibold ${!n.read ? 'text-gray-900' : 'text-gray-600'}`}>{n.title}</p>
                  <p className="text-xs text-gray-500 mt-0.5 line-clamp-2">{n.message}</p>
                  <p className="text-[10px] text-gray-400 mt-1">{timeAgo(n.createdAt)}</p>
                </div>
                {!n.read && <span className="w-1.5 h-1.5 rounded-full bg-[#1086a4] flex-shrink-0 mt-1.5" />}
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};

export default NotificationDropdown;
